<template>
    <div>
        <!-- Title and Logo -->
        <HeaderCard />
        <!-- end Logo and Title -->

        <!-- Panel Start here -->
        <panel title="Surat Tanda Setoran" class="panel panel-dark">
            <!-- BAGIAN TOOLS LIST -->
            <b-row>
                <b-col md="12">
                    <b-card border-variant="dark" header-tag="header" footer-tag="footer">
                        <template #header>
                            <!-- <div class="pull-right">
                                <b-button class="pull-right" variant="primary" @click="create">
                                    <i class="fa fa-plus pr-1"></i> Tambah SPT
                                </b-button>
                            </div> -->
                            <h6 class="mb-0">Tools</h6>
                        </template>
                        
                        <!-- FILTER -->
                        <b-card-body class="p-0 m-0">
                            <b-row>
                                <b-col md="6">
                                    <b-form-group
                                        :label-cols="3"
                                        label="Filter By"
                                        class="mb-1"
                                    >
                                        <b-input-group size="md">
                                            <b-form-select
                                                v-model="filterBy"
                                                :options="fieldOptions"
                                                @change="changeFilterBy()"
                                            >
                                                <option slot="first" :value="'all'"
                                                    >All Data</option
                                                >
                                            </b-form-select>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group
                                        :label-cols="3"
                                        label="Filter"
                                        class="mb-0"
                                        description="Type to Search or Click Clear to Stop Searching "
                                    >
                                        <b-input-group size="md">
                                            <b-form-input
                                                v-model="filter"
                                                @keyup.enter="testFunc(filter)"
                                                placeholder="Type to Search"
                                                debounce="500"
                                            />
                                            <b-input-group-append>
                                                <b-btn
                                                    :disabled="!filter"
                                                    @click="filter = ''"
                                                    variant="info"
                                                    >Clear</b-btn
                                                >
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group
                                        :label-cols="3"
                                        label="Sort"
                                        class="mb-1"
                                    >
                                        <b-input-group size="md">
                                            <b-form-select
                                                v-model="sortBy"
                                                :options="fieldOptions"
                                            >
                                                <option slot="first" :value="null">-- none --</option>
                                            </b-form-select>
                                            <b-form-select
                                                :disabled="!sortBy"
                                                v-model="sortDesc"
                                                slot="append"
                                            >
                                                <option :value="false">Asc</option>
                                                <option :value="true">Desc</option>
                                            </b-form-select>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            
                        </b-card-body>
                        <!-- end FILTER -->

                        <!--
                        <div class="pull-right mx-0 my-0">
                            <b-button variant="primary" to="/menu/sptrd/pendaftaran">
                                <i class="fa fa-plus pr-1"></i> Tambah SPTRD
                            </b-button>
                        </div> -->
                        <template #footer>
                            <!-- <em>Footer Slot</em> -->
                            <div class="pull-right">
                                <b-button variant="primary" @click="reload">
                                    <i class="fa fa-sync-alt pr-1"></i> Muat Ulang
                                </b-button>
                                <!-- <b-button class="ml-2" variant="primary" to="/menu/sptrd/pendaftaran">
                                    <i class="fa fa-plus pr-1"></i> Tambah SPTRD
                                </b-button> -->
                            </div>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
            <!-- end BAGIAN TOOLS LIST -->

            <hr class="my-2">

            <!-- Data Table & Pagination -->
            <b-table
                show-empty
                small
                id="tableJabatan"
                ref="tableJabatan"
                head-variant="light"
                :hover="true"
                :busy.sync="isBusy"
                :items="myGetData"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                responsive
            >
                <!-- loading -->
                <template v-slot:table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner
                            class="align-middle"
                            small
                            variant="primary"
                        ></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <!-- header title -->
                <template #head()="data">
                    <div v-html="data.label"></div>
                    <!-- <span style="white-space: pre;">
                        {{ data.label }}</span> -->
                </template>
                <!-- column width -->
                <template v-slot:table-colgroup="scope">
                    <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{
                            width: field.key === 'status_ssr' ? '125px' : 
                                field.key === 'actions' ? '95px' : ''
                        }"
                    />
                </template>
                <!-- nomor -->
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>

                <!-- surat ketetapan -->
                <template #cell(surat)="data">
                    <div v-if="data.item.surat">
                        <div>
                            {{ data.item.surat.no_surat }}
                        </div>
                        <div>
                            {{ data.item.surat.tgl_surat }}
                        </div>
                    </div>
                </template>

                <!-- STS -->
                <template #cell(no_sts)="data">
                    <div>
                        {{ data.item.no_sts }}
                    </div>
                    <div>
                        {{ data.item.tgl_sts }}
                    </div>
                </template>

                <!-- RUPS -->
                <template #cell(nilai_terutang)="data">
                    <div class="text-right">
                        {{
                            data.item.nilai_terutang
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                        }}
                    </div>
                </template>

                <!-- status bayar -->
                <template #cell(status_ssr)="data">
                    <div v-if="data.item.status_ssr">
                        <div
                            v-if="data.item.status_ssr.id == 6"
                        >
                            <div
                            :class="
                                `label label-${data.item.status_ssr.warna}`
                            " 
                            >
                                {{ data.item.status_ssr.nama }}
                            </div>
                            <div>
                                {{ data.item.dibuat_tgl }}
                            </div>
                        </div>
                        <div
                            v-if="data.item.status_ssr.id == 7"
                        >
                            <div
                                :class="
                                `label label-${data.item.status_ssr.warna}`
                            "
                            >
                                {{ data.item.status_ssr.nama }}
                            </div>
                        </div>
                        <div
                            v-if="data.item.status_ssr.id == 8"
                        >
                            <div
                                :class="
                                `label label-${data.item.status_ssr.warna}`
                            "
                            >
                                {{ data.item.status_ssr.nama }}
                            </div>
                            <div>
                                {{ data.item.disetor_tgl }}
                            </div>
                        </div>
                        <div
                            v-if="data.item.status_ssr.id == 9"
                        >
                            <div
                                :class="
                                `label label-${data.item.status_ssr.warna}`
                            "
                            >
                                {{ data.item.status_ssr.nama }}
                            </div>
                            <div>
                                {{ data.item.dibatalkan_tgl }}
                            </div>
                        </div>
                    </div>
                </template>
                <!-- button actions -->
                <template v-slot:cell(actions)="data">
                    <div
                        class="d-flex align-item-center"
                        :style="'width: 92px'"
                    >
                        <b-dropdown
                            split
                            class="m-r-2 d-flex align-item-center"
                            size="sm"
                            variant="info"
                        >
                            <template #button-content>
                                <i class="fa fa-cogs"></i> Aksi
                            </template>
                            <b-dropdown-item disabled
                                ><i class="fa fa-edit"></i>
                                Edit</b-dropdown-item
                            >
                            <b-dropdown-item disabled
                                ><i class="fa fa-trash-alt"></i>
                                Hapus</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="kodeBayarPdf(data.item.no_sts)"
                            >
                                <i class="fa fa-file-pdf"></i> Kode Bayar
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </template>
                <!-- end button actions -->
            </b-table>
            <div class="divider"></div>

            <!-- pagination section -->
            <b-row>
                <div class="divider"></div>
                <b-col md="6" class="my-0">
                    <b-form-group
                        :label-cols="2"
                        label="Per page"
                        class="mb-0"
                    >
                        <b-form inline>
                            <b-form-select
                                :options="pageOptions"
                                style="width: 100px;"
                                v-model="perPage"
                            />
                            <label class="ml-1 mr-1">/</label>
                            <b-form-input
                                :disabled="true"
                                v-model="totalRows"
                                style="width: 100px;"
                                class="text-right"
                            />
                            <label class="ml-1">Rows</label>
                        </b-form>
                    </b-form-group>
                </b-col>
                <b-col md="6" class="my-0">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        size="md"
                        class="my-0 "
                    ></b-pagination>
                </b-col>
            </b-row>
            <!-- end pagination section -->
        </panel>
        <!-- Selesai button loader -->
        <b-modal
            v-model="helper.showLoader"
            id="modalLoader"
            hide-footer
            hide-header
            no-close-on-backdrop
            centered
            size="sm"
        >
            <div class="text-center text-primary">
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
                <h5>Harap Menunggu...</h5>
                <div>Data Anda Sedang Di Proses</div>
            </div>
        </b-modal>
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import HeaderCard from "@/components/header/HeaderCard.vue";
import axios from "axios";
import deleteMixins from "@/helper/delete_api";
import cekAuthMixins from "@/helper/cek401";
import resetMixins from "@/helper/resetForm";
import { mapState } from "vuex";
import jabatanMixin from "@/helper/jabatan/jabatan";

export default {
    mixins: [deleteMixins, cekAuthMixins, resetMixins, jabatanMixin],
    components: {
        HeaderCard
    },
    data() {
        return {
            // tools
            filter: "",
            filterBy: "all",
            sortBy: null,
            sortDesc: false,
            pageOptions: [5, 10, 15, 25],
            perPage: 10,
            currentPage: 1,
            totalRows: 0,
            isBusy: false,
            // field table
            fields: [
                {
                    key: "index",
                    label: "No.",
                    tdClass: "text-right"
                },
                {
                    key: "surat",
                    label: "No./Tgl. Surat Ketetapan",
                    sortable: true
                },
                {
                    key: "no_sts",
                    label: "No./Tgl. STS",
                    sortable: true
                },
                {
                    key: "tahun",
                    label: "Tahun Buku"
                },
                {
                    key: "nilai_terutang",
                    label: "Jumlah <br>(IDR)",
                    sortable: true
                },
                {
                    key: "status_ssr",
                    label: "Status <br>Pemindah Bukuan",
                    sortable: true
                },
                {
                    key: "actions",
                    label: "Opsi"
                }
            ],
            // modal
            showModal: false,
            editMode: false,
            isLoading: false,
            // v-form
            form: new Form({
                unit_pd_id: "",
                no_urut: "",
                kategori: "",
                eselon: "",
                nama: "",
                singkatan: ""
            }),
            // helper variable
            helper: {
                perangkat: "",
                errors: "",
                jabatan: "",
                showLoader: false,
                pdfUrl: ""
            }
        };
    },
    computed: {
        fieldOptions() {
            // Create an options list from our fields
            return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        },
        // unit store variable
        ...mapState(["PemerintahDaerah"])
    },
    mounted() {
        // call unit option api (vuex)
        this.$store.dispatch("PemerintahDaerah/getPerangkatOptions");
    },
    methods: {
        // hot reload when input filter
        changeFilterBy() {
            if (this.filter) {
                this.$refs.tableJabatan.refresh();
            }
        },
        // data table
        myGetData(ctx) {
            // ctx =
            // berasal dari tag <b-table></b-table>
            //this.$Progress.start();
            this.isBusy = true;
            let promise = axios.get("/api/transaksi/kode-bayar", {
                params: {
                    page: ctx.currentPage,
                    perpage: ctx.perPage,
                    sortby: ctx.sortBy,
                    sortdesc: ctx.sortDesc,
                    filter: ctx.filter,
                    filterby: this.filterBy
                }
            });
            return promise
                .then(response => {
                    const items = response.data.data;
                    // Data Pagination
                    // configPagination(response.data.meta);
                    this.totalRows = response.data.meta.total;
                    // Here we could override the busy state, setting isBusy to false
                    //this.$Progress.finish();
                    this.isBusy = false;
                    // console.log(items);
                    return items;
                })
                .catch(error => {
                    // console.error(error);
                    // Here we could override the busy state, setting isBusy to false
                    //this.$Progress.fail();
                    this.isBusy = false;
                    if (error.response.status == 401) {
                        /* 
                        fungsi ini berasal dari cekAuthMixins 
                        cek pada folder 'helper'
                        */
                        this.cekAuth();
                    }
                    // Returning an empty array, allows table to correctly handle
                    // internal busy state in case of error
                    return [];
                });
        },
        // hapus data
        remove(id) {
            this.$swal({
                title: "Anda yakin ?",
                text: "Anda tidak akan bisa mengembalikan data!",
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: "Hapus",
                cancelButtonText: "Cancel",
                confirmButtonClass: "btn m-r-5 btn-danger",
                cancelButtonClass: "btn btn-default"
            }).then(result => {
                if (result.isConfirmed) {
                    // fungsi dari deleteMixins "cek folder 'helper'"
                    this.delete(id, "/api/data-induk/kepegawaian/jabatan/");
                }
            });
        },
        // reload table
        reload() {
            this.$refs.tableJabatan.refresh();
        },
        // modal function
        create() {
            // fungsi berasal dari resetMixins
            this.helper = {
                perangkat: "",
                errors: ""
            };
            this.reset(this.helper);
            // =================
            this.editMode = false;
            this.$root.$emit("bv::show::modal", "modal");
            this.showModal = true;
        },
        // edit modal
        edit(id) {
            // fungsi berasal dari resetMixins
            this.helper = {
                perangkat: "",
                errors: ""
            };
            this.reset(this.helper);
            this.editMode = true;
            this.$root.$emit("bv::show::modal", "modal");
            this.showModal = true;
            this.helper.jabatan_id = id;
            this.detail(id);
        },
        // close modal
        close() {
            this.helper = {
                perangkat: "",
                errors: ""
            };
            this.reset(this.helper);
            this.editMode = false;
            this.$root.$emit("bv::hide::modal", "modal");
            this.showModal = false;
        },
        // input Perangkat
        inputPerangkat(perangkatId) {
            if (perangkatId) {
                // 'PemerintahDaerah' vuex (cek folder store)
                this.$store.dispatch(
                    "PemerintahDaerah/getUnitOptions",
                    perangkatId
                );
            } else {
                this.form.unit_pd_id = "";
            }
        },
        // view pdf kode bayar
        async kodeBayarPdf(no_sts) {
            try {
                this.helper.showLoader = true;
                let response = await axios.get(
                    `/api/view-pdf/surat/ssr/by-sts/${no_sts}`,
                    { responseType: "arraybuffer" }
                );
                if (response.data) {
                    this.helper.showLoader = false;
                    this.helper.pdfUrl = window.URL.createObjectURL(
                        new Blob([response.data], { type: "application/pdf" })
                    );
                    window.open(this.helper.pdfUrl, "_blank");
                }
            } catch (error) {
                this.helper.showLoader = false;
                // console.log(error);
                if (error.response.status == 401) {
                    // mixins - cek auth
                    this.cekAuth();
                }
            }
        }
    }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    border-color: red;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #394066;
}
</style>
